import React from 'react';
import { Box, Typography, Divider } from '@mui/material';
import { Table as AntTable, Tag, Button as AntButton, Select, Input, Spin } from 'antd';
import type { ColumnsType } from 'antd/es/table';

interface Tab3Props {
  allGroupes: any[];
  modulesParGroupe: any[];
  modulesAutorises: any[];
  selectedCodGroup: string;
  onLoadModulesParGroupe: (codGroup: string) => void;
  onLoadModulesAutorises: () => void;
  authHeader: () => string;
  user: any;
}

const moduleColumns: ColumnsType<any> = [
  { title: 'Code', dataIndex: 'CodModule', key: 'CodModule', width: 120 },
  { title: 'Libellé', dataIndex: 'Libelle', key: 'Libelle', width: 200 },
  { title: 'Catégorie', dataIndex: 'CodCategorie', key: 'CodCategorie', width: 120 },
  { title: 'Ordre', dataIndex: 'Ordre', key: 'Ordre', width: 70, align: 'center' as const },
  {
    title: 'Actif',
    dataIndex: 'Actif',
    key: 'Actif',
    width: 70,
    align: 'center' as const,
    render: (v: boolean) => <Tag color={v ? '#116599' : 'red'}>{v ? 'Oui' : 'Non'}</Tag>,
  },
];

function Tab3(props: Tab3Props) {
  const [searchModuleGroupe, setSearchModuleGroupe] = React.useState('');
  const [searchModuleAutorise, setSearchModuleAutorise] = React.useState('');

  const handleSelectGroup = (value: string) => {
    if (value) {
      props.onLoadModulesParGroupe(value);
    }
  };

  const filteredModulesParGroupe = React.useMemo(() => {
    if (!searchModuleGroupe) return props.modulesParGroupe;
    const lower = searchModuleGroupe.toLowerCase();
    return props.modulesParGroupe.filter(
      (m: any) =>
        (m.CodModule || '').toLowerCase().includes(lower) ||
        (m.Libelle || '').toLowerCase().includes(lower) ||
        (m.CodCategorie || '').toLowerCase().includes(lower)
    );
  }, [props.modulesParGroupe, searchModuleGroupe]);

  const filteredModulesAutorises = React.useMemo(() => {
    if (!searchModuleAutorise) return props.modulesAutorises;
    const lower = searchModuleAutorise.toLowerCase();
    return props.modulesAutorises.filter(
      (m: any) =>
        (m.CodModule || '').toLowerCase().includes(lower) ||
        (m.Libelle || '').toLowerCase().includes(lower) ||
        (m.CodCategorie || '').toLowerCase().includes(lower)
    );
  }, [props.modulesAutorises, searchModuleAutorise]);

  return (
    <div className='tabItem'>
      <Box display={"flex"} fontStyle='inherit' className='border' width={'88%'} position={'relative'}>
        
        {/* Section 1: Modules par groupe */}
        <Box fontStyle='inherit' className='border' position={'relative'} sx={{ mb: 2, borderRadius: 2, p: 2 }}>
          <Typography variant='h6' fontWeight='bold' sx={{ mb: 2 }}>
            Modules par groupe
          </Typography>
          <Box display='flex' alignItems='center' gap={2} sx={{ mb: 2 }}>
            <Select
              showSearch
              style={{ width: 350 }}
              placeholder='Sélectionner un groupe...'
              optionFilterProp='label'
              value={props.selectedCodGroup || undefined}
              onChange={handleSelectGroup}
              options={props.allGroupes.map((g: any) => ({
                value: g.CodGroup,
                label: `${g.CodGroup} - ${g.Libelle}`,
              }))}
            />
            <Typography variant='body2' color='textSecondary'>
              {props.modulesParGroupe.length > 0
                ? `${props.modulesParGroupe.length} module(s) trouvé(s)`
                : 'Aucun module chargé'}
            </Typography>
          </Box>
          <Box display='flex' justifyContent='flex-end' sx={{ mb: 1 }}>
            <Input.Search
              placeholder='Rechercher un module...'
              allowClear
              size='small'
              style={{ width: 250 }}
              onChange={(e) => setSearchModuleGroupe(e.target.value)}
              disabled={props.modulesParGroupe.length === 0}
            />
          </Box>
          <AntTable
            size='small'
            columns={moduleColumns}
            dataSource={filteredModulesParGroupe}
            rowKey='CodModule'
            pagination={{ pageSize: 6, showSizeChanger: false }}
            scroll={{ y: 250, x: 600 }}
            locale={{ emptyText: 'Sélectionnez un groupe pour afficher ses modules' }}
          />
        </Box>

        <Divider />

        {/* Section 2: Modules autorisés pour l'utilisateur connecté */}
        <Box fontStyle='inherit' className='border' position={'relative'} sx={{ borderRadius: 2, p: 2 }}>
          <Box display='flex' justifyContent='space-between' alignItems='center' sx={{ mb: 2 }}>
            <Typography variant='h6' fontWeight='bold'>
              Modules autorisés pour l'utilisateur courant
            </Typography>
            <AntButton type='primary' onClick={props.onLoadModulesAutorises}>
              Charger mes modules autorisés
            </AntButton>
          </Box>
          <Box display='flex' justifyContent='flex-end' sx={{ mb: 1 }}>
            <Input.Search
              placeholder='Rechercher un module...'
              allowClear
              size='small'
              style={{ width: 250 }}
              onChange={(e) => setSearchModuleAutorise(e.target.value)}
              disabled={props.modulesAutorises.length === 0}
            />
          </Box>
          <AntTable
            size='small'
            columns={moduleColumns}
            dataSource={filteredModulesAutorises}
            rowKey='CodModule'
            pagination={{ pageSize: 6, showSizeChanger: false }}
            scroll={{ y: 250, x: 600 }}
            locale={{ emptyText: 'Cliquez sur "Charger mes modules autorisés" pour afficher vos modules' }}
          />
        </Box>
      </Box>



    </div>
  );
}

export default Tab3;
